import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Table } from 'react-bootstrap';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { PENDING } from '../../../constants/JobStatus';
class DriverJobsModal extends Component {
    getTitle() {
        const { type, name, t } = this.props;
        if (type === PENDING) {
            return t('OFFERS_FOR_NAME', { name });
        }
        return t('JOBS_FOR_NAME', { name });
    }
    renderJobItems() {
        const { jobs = [], t } = this.props;
        if (!jobs || jobs.length === 0) {
            return (React.createElement("tr", null,
                React.createElement("td", { colSpan: 4 }, t('THERE_ARE_NO_JOBS'))));
        }
        return jobs.map((job, i) => {
            const jobDetaiLink = `/shipments/${job._id}`;
            let originName = '';
            let destinationName = '';
            if (job.origin && job.origin.length > 0) {
                originName = job.origin[0].name;
            }
            if (job.destination && job.destination.length > 0) {
                destinationName = job.destination[0].name;
            }
            const flatTimeline = Object.values(job.timeline);
            const currentStatus = _.last(_.sortBy(flatTimeline, (e) => e.status.code))
                .status.message;
            return (React.createElement("tr", { key: i },
                React.createElement("td", null,
                    React.createElement("a", { href: jobDetaiLink }, job.shipment_id)),
                React.createElement("td", null,
                    React.createElement("span", null, originName)),
                React.createElement("td", null,
                    React.createElement("span", null, destinationName)),
                React.createElement("td", null,
                    React.createElement("span", null, currentStatus))));
        });
    }
    render() {
        const { t } = this.props;
        return (React.createElement(Modal, { show: this.props.isOpen },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, this.getTitle())),
            React.createElement(Modal.Body, null,
                React.createElement(Table, { condensed: true, striped: true, hover: true, className: "driver-jobs-table" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null,
                                titleize(t('SHIPMENT')),
                                " #"),
                            React.createElement("th", null, titleize(t('ORIGIN'))),
                            React.createElement("th", null, titleize(t('DESTINATION'))),
                            React.createElement("th", null, t('STATUS')))),
                    React.createElement("tbody", null, this.renderJobItems()))),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { onClick: () => this.props.onClose() }, "Close"))));
    }
}
DriverJobsModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    name: PropTypes.string,
    jobs: PropTypes.array,
    type: PropTypes.string.isRequired,
};
DriverJobsModal.defaultProps = {
    name: '',
    jobs: [],
};
export default withTranslation()(DriverJobsModal);
